import { MAX_ITEMS } from './expenseOptions.js';

// Choosing receipt files for a background import. The server checks everything again (by content,
// not by name); these checks only save a round trip and say what is wrong in plain words.

const MAX_FILE_BYTES = 5 * 1024 * 1024;

export const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '')} MB`;
};

/**
 * Which chosen files can go: images and PDFs under 5 MB, not chosen before, up to the room left on
 * the report. `earlier` are the files already in the list.
 */
export const acceptFiles = (files, room, earlier = []) => {
    const accepted = [];
    const rejected = [];
    const seen = new Set(earlier.map(e => `${e.name}|${e.size}`));
    for (const file of files) {
        const key = `${file.name}|${file.size}`;
        if (!(file.type?.startsWith('image/') || file.type === 'application/pdf')) rejected.push({ name: file.name, reason: 'Not an image or a PDF' });
        else if (file.size > MAX_FILE_BYTES) rejected.push({ name: file.name, reason: `${formatSize(file.size)} is over the 5 MB limit` });
        else if (seen.has(key)) rejected.push({ name: file.name, reason: 'Already chosen' });
        else if (accepted.length >= room) rejected.push({ name: file.name, reason: `A report can have at most ${MAX_ITEMS} lines` });
        else { accepted.push(file); seen.add(key); }
    }
    return { accepted, rejected };
};

/** Split into upload requests of at most `maxFiles` files and `maxBytes` bytes. A file over the byte budget still goes, alone. */
export const chunkFiles = (files, maxFiles, maxBytes) => {
    const groups = [];
    let current = [];
    let bytes = 0;
    for (const file of files) {
        if (current.length && (current.length >= maxFiles || bytes + file.size > maxBytes)) {
            groups.push(current);
            current = [];
            bytes = 0;
        }
        current.push(file);
        bytes += file.size;
    }
    if (current.length) groups.push(current);
    return groups;
};
